import { render, staticRenderFns } from "./Init.vue?vue&type=template&id=70681e6a&scoped=true&"
import script from "./Init.vue?vue&type=script&lang=ts&"
export * from "./Init.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70681e6a",
  null
  
)

export default component.exports